function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import * as DialogPrimitive from '@grupoboticario/flora-react-dialog';
import { baseAnimation, forwardRef, keyframes, styled } from '@grupoboticario/flora-react-system';

/**
 * @component
 * @name Drawer
 * @description Drawer component
 * @tutorial https://flora.gb.tech/docs/components/core/drawer
 */
export var Drawer = props => {
  return /*#__PURE__*/React.createElement(DialogPrimitive.Dialog, _extends({}, props, {
    "data-flora": "drawer"
  }));
};
var slideIn = keyframes({
  from: {
    transform: '$$transformValue'
  },
  to: {
    transform: 'translate3d(0,0,0)'
  }
});
var slideOut = keyframes({
  from: {
    transform: 'translate3d(0,0,0)'
  },
  to: {
    transform: '$$transformValue'
  }
});
var StyledContent = styled(DialogPrimitive.DialogContent, {
  backgroundColor: '$backgroundPrimary',
  boxShadow: '$colors$shadowLight 0 0 38px -10px, $colors$shadowDark 0 0 35px -15px',
  position: 'fixed',
  top: 0,
  bottom: 0,
  width: '100%',
  willChange: 'transform',
  display: 'flex',
  flexDirection: 'column',
  zIndex: '$modal',
  '&[data-state="open"]': {
    animation: slideIn + " " + baseAnimation
  },
  '&[data-state="closed"]': {
    animation: slideOut + " " + baseAnimation
  },
  variants: {
    side: {
      top: {
        $$transformValue: 'translate3d(0,-100%,0)',
        width: '100%',
        height: 'auto',
        minHeight: 60,
        left: 0,
        bottom: 'auto'
      },
      right: {
        $$transformValue: 'translate3d(100%,0,0)',
        right: 0,
        '@tablet': {
          width: 380
        }
      },
      bottom: {
        $$transformValue: 'translate3d(0,100%,0)',
        width: '100%',
        height: 'auto',
        minHeight: 60,
        bottom: 0,
        left: 0,
        top: 'auto'
      },
      left: {
        $$transformValue: 'translate3d(-100%,0,0)',
        left: 0,
        '@tablet': {
          width: 380
        }
      }
    },
    isFull: {
      true: {
        width: '100%',
        height: '100%'
      }
    }
  },
  defaultVariants: {
    side: 'right'
  }
});
var StyledBody = styled(DialogPrimitive.DialogBody, {});
var StyledHeader = styled(DialogPrimitive.DialogHeader, {});
var StyledFooter = styled(DialogPrimitive.DialogFooter, {});
var StyledTrigger = styled(DialogPrimitive.DialogTrigger, {});
var StyledClose = styled(DialogPrimitive.DialogClose, {});

/**
 * @tutorial https://flora.gb.tech/docs/components/core/drawer
 */
export var DrawerContent = forwardRef((props, forwardedRef) => {
  return /*#__PURE__*/React.createElement(StyledContent, _extends({}, props, {
    "data-flora": "drawer-content",
    ref: forwardedRef
  }));
});

/**
 * @tutorial https://flora.gb.tech/docs/components/core/drawer
 */
export var DrawerBody = forwardRef((props, forwardedRef) => {
  return /*#__PURE__*/React.createElement(StyledBody, _extends({}, props, {
    "data-flora": "drawer-body",
    ref: forwardedRef
  }));
});

/**
 * @tutorial https://flora.gb.tech/docs/components/core/drawer
 */
export var DrawerHeader = forwardRef((props, forwardedRef) => {
  return /*#__PURE__*/React.createElement(StyledHeader, _extends({}, props, {
    "data-flora": "drawer-header",
    ref: forwardedRef
  }));
});

/**
 * @tutorial https://flora.gb.tech/docs/components/core/drawer
 */
export var DrawerFooter = forwardRef((props, forwardedRef) => {
  return /*#__PURE__*/React.createElement(StyledFooter, _extends({}, props, {
    "data-flora": "drawer-footer",
    ref: forwardedRef
  }));
});

/**
 * @tutorial https://flora.gb.tech/docs/components/core/drawer
 */
export var DrawerTrigger = forwardRef((props, forwardedRef) => {
  return /*#__PURE__*/React.createElement(StyledTrigger, _extends({}, props, {
    asChild: true,
    "data-flora": "drawer-trigger",
    ref: forwardedRef
  }));
});

/**
 * @tutorial https://flora.gb.tech/docs/components/core/drawer
 */
export var DrawerCloseButton = forwardRef((props, forwardedRef) => {
  return /*#__PURE__*/React.createElement(StyledClose, _extends({}, props, {
    "data-flora": "drawer-close",
    ref: forwardedRef
  }));
});
//# sourceMappingURL=Drawer.js.map